import { SvgIcon } from '@mui/material';
import type { SvgIconProps } from '@mui/material/SvgIcon';

import type { IconType } from '../../types';

const IconName = 'Folder';

const IconSvg = `
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M3 5.25C3 4.00736 4.00736 3 5.25 3H9.12868C9.72542 3 10.2977 3.23705 10.7197 3.65901L11.341 4.28033C11.4816 4.42098 11.6724 4.5 11.8713 4.5H17.25C18.4926 4.5 19.5 5.50736 19.5 6.75V7.52767C20.748 7.72428 21.6193 8.93941 21.3446 10.2214L19.7374 17.7214C19.5151 18.7588 18.5983 19.5 17.5374 19.5H3.75C3.33579 19.5 3 19.1642 3 18.75V5.25ZM18 7.5V6.75C18 6.33579 17.6642 6 17.25 6H11.8713C11.2746 6 10.7023 5.76295 10.2803 5.34099L9.65901 4.71967C9.51836 4.57902 9.32759 4.5 9.12868 4.5H5.25C4.83579 4.5 4.5 4.83579 4.5 5.25V11.6705L5.01257 9.27856C5.23487 8.24115 6.15166 7.5 7.21262 7.5H18ZM4.67774 18H17.5374C17.891 18 18.1966 17.7529 18.2707 17.4071L19.8779 9.90715C19.9779 9.44026 19.622 9 19.1445 9H7.21262C6.85897 9 6.55337 9.24705 6.47927 9.59285L4.67774 18Z" fill="currentColor"/>
  </svg>
`;

const FolderIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3 5.25C3 4.00736 4.00736 3 5.25 3H9.12868C9.72542 3 10.2977 3.23705 10.7197 3.65901L11.341 4.28033C11.4816 4.42098 11.6724 4.5 11.8713 4.5H17.25C18.4926 4.5 19.5 5.50736 19.5 6.75V7.52767C20.748 7.72428 21.6193 8.93941 21.3446 10.2214L19.7374 17.7214C19.5151 18.7588 18.5983 19.5 17.5374 19.5H3.75C3.33579 19.5 3 19.1642 3 18.75V5.25ZM18 7.5V6.75C18 6.33579 17.6642 6 17.25 6H11.8713C11.2746 6 10.7023 5.76295 10.2803 5.34099L9.65901 4.71967C9.51836 4.57902 9.32759 4.5 9.12868 4.5H5.25C4.83579 4.5 4.5 4.83579 4.5 5.25V11.6705L5.01257 9.27856C5.23487 8.24115 6.15166 7.5 7.21262 7.5H18ZM4.67774 18H17.5374C17.891 18 18.1966 17.7529 18.2707 17.4071L19.8779 9.90715C19.9779 9.44026 19.622 9 19.1445 9H7.21262C6.85897 9 6.55337 9.24705 6.47927 9.59285L4.67774 18Z'
      fill='currentColor'
    />
  </SvgIcon>
);

export default {
  name: IconName,
  title: IconName,

  IconComponent: FolderIcon,
  IconSvg: IconSvg
} as IconType;
